import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../services/auth';

/**
 * Renders when path is exactly "/".
 * Redirects to /login if not authenticated, or to /:tenantCode/ if authenticated.
 */
function RootRedirect() {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  const tenantCode = getUser()?.tenant?.code;
  if (!tenantCode) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={`/${tenantCode}/dashboard`} replace />;
}

export default RootRedirect;
